var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDownloadAllIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8332 5.83333L9.90359 3.9741C9.636 3.439 9.50225 3.17144 9.30267 2.97597C9.12617 2.80311 8.91342 2.67164 8.67992 2.59109C8.41584 2.5 8.11668 2.5 7.51841 2.5H4.33317C3.39975 2.5 2.93304 2.5 2.57652 2.68166C2.26291 2.84144 2.00795 3.09641 1.84816 3.41002C1.6665 3.76653 1.6665 4.23325 1.6665 5.16667V5.83333M1.6665 5.83333H14.3332C15.7333 5.83333 16.4333 5.83333 16.9682 6.10582C17.4386 6.3455 17.821 6.72795 18.0607 7.19836C18.3332 7.73313 18.3332 8.43317 18.3332 9.83333V13.5C18.3332 14.9002 18.3332 15.6002 18.0607 16.135C17.821 16.6054 17.4386 16.9878 16.9682 17.2275C16.4333 17.5 15.7333 17.5 14.3332 17.5H5.6665C4.26637 17.5 3.5663 17.5 3.03153 17.2275C2.56112 16.9878 2.17867 16.6054 1.93899 16.135C1.6665 15.6002 1.6665 14.9002 1.6665 13.5V5.83333ZM7.49984 11.6667L9.99984 14.1667M9.99984 14.1667L12.4998 11.6667M9.99984 14.1667V9.16667",
    stroke: "#374151",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadAllIcon);
export default __webpack_public_path__ + "static/media/Download_all_icon.7a23111d19dcc8bc4ba06f760bc95904.svg";
export { ForwardRef as ReactComponent };